
<div
  v-if="props.showError && props.error.hasError"
  :class="{ [`text-${props.error.level}`]: !!props.error.level }"
  class="invalid-feedback mb-1"
>
  {{ props.error.getMessage() }}
</div>
